import React from 'react'
import { Row, Col, Container } from 'react-bootstrap'


function AndThenThere({ data }) {
  return (
    <> 
    {(data) && (
    <section className="and-then-there">
      <Container>
        <Row className="align-items-center">
          <Col sm="12" md="6" className='mb-4 mb-md-0'>
            <img className="and-then-there-img" src={`${process.env.REACT_APP_PHP_BACKEND_MEDIA_URL}${data.image}`} alt="" />
          </Col>     
          <Col sm="12" md="6">    
            <div className="and-then-there-box">        
              <h2>{data.title}</h2>
              <p>{data.subTitle}</p>
              <div dangerouslySetInnerHTML={{ __html: data.description }}></div>
            </div>
          </Col>
        </Row>        
      </Container>
    </section>
    )}
    </>
  )
}
export default AndThenThere